import { useTranslation } from "react-i18next"
import * as yup from "yup"
import { translationKeys } from "../../../util/translationKeys"

const numberRegex = /^[^a-zA-Z]*$/

export const useConfirmCodeSchemaProperties = () => {
  const { t } = useTranslation()
  const confirmCodeSchemaProperties = yup.object().shape({
    valueOne: yup
      .string()
      .matches(numberRegex, `${t(translationKeys.inputConfirmCodeNotNumber)}`)
      .required(`${t(translationKeys.inputConfirmCodeEnterValue)}`),
    valueTwo: yup
      .string()
      .matches(numberRegex, `${t(translationKeys.inputConfirmCodeNotNumber)}`)
      .required(`${t(translationKeys.inputConfirmCodeEnterValue)}`),
    valueThree: yup
      .string()
      .matches(numberRegex, `${t(translationKeys.inputConfirmCodeNotNumber)}`)
      .required(`${t(translationKeys.inputConfirmCodeEnterValue)}`),
    valueFour: yup
      .string()
      .matches(numberRegex, `${t(translationKeys.inputConfirmCodeNotNumber)}`)
      .required(`${t(translationKeys.inputConfirmCodeEnterValue)}`),
  })
  return confirmCodeSchemaProperties
}
